<template>
  <bm-btn :id="activatorId" v-bind="$attrs" :data-qa="$m.keys.more">
    <!-- This uses a selected activator as the button is already connected to a tooltip activator (slot style activator) -->
    <v-menu offset-y :activator="'#' + activatorId" :top="top">
      <v-list data-qa="bm-btn-dropdown-list">
        <v-list-item
          v-for="(item, index) in items"
          :key="index"
          link
          :to="item.to"
          :class="{ 'hide-list-element': item.hidden }"
          :disabled="item.disabled"
          @click="!item.to && item.action && item.action($event, item.item)"
        >
          <v-list-item-title>
            <bm-icon v-if="item.icon" :icon="item.icon" />
            <v-icon
              v-else-if="item.iconConfig"
              :size="item.iconConfig.width"
              :style="{ height: item.iconConfig.height }"
              :class="item.iconConfig.class"
            />
            {{ item.text }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <div style="width: 100%">
      <slot />
    </div>
    <bm-icon v-if="!footer" icon="ExpandMore" />
  </bm-btn>
</template>

<script setup lang="ts">
import BmBtn from "@/components/controls/input/BmBtn.vue";
import { getUniqueId } from "@/components/composables/unique";
import type { BmBtnDropdownMenuItem } from "@/components/controls/input/types/BmBtnDropdownTypes";

interface BmBtnDropdownProps {
  items: BmBtnDropdownMenuItem[];
  top?: boolean;
  footer?: boolean;
}

withDefaults(defineProps<BmBtnDropdownProps>(), {
  top: false,
  footer: false,
});

// Unique id to assign to the button and attach the activator to.
const activatorId = getUniqueId();
</script>

<style lang="sass" scoped>
.hide-list-element
  display: none !important
</style>
